// extracted by mini-css-extract-plugin
export default {"loader":"FeedCardLoader_loader__xvRV4"};